<template>
    <div
        v-if="!loading && (resultsCount === 0 || resultsCount <= maxResultsToShowRecommendations)"
        class="NoResultsWrapper"
    >
        <div class="NoResultsRecommendations">
            <p v-if="resultsCount === 0" class="NoResultsText">
                No results for {{ pageTitle }}
            </p>
            <div
                v-if="resultsCount <= maxResultsToShowRecommendations"
                class="LowResultsContent"
            >
                <span class="RemoveFiltersSuggestionsTitle">Try removing some of your filters</span>
                <SelectedFiltersSection :showClear="false"/>
                <LowResultsSuggestion/>
            </div>
            <Recommendations v-if="resultsCount === 0"/>
        </div>
    </div>

</template>

<script setup lang="ts">
import { useSearchStore } from '@app/stores/useSearchStore';
import { computed } from 'vue';
import SelectedFiltersSection from '@app/components/Filters/SelectedFiltersSection/SelectedFiltersSection.vue';
import LowResultsSuggestion from '@app/components/SearchResults/LowResults/LowResultsSuggestions/LowResultsSuggestions.vue';
import Recommendations from '@app/components/Recommendations/Recommendations.vue';

const searchStore = useSearchStore();
const maxResultsToShowRecommendations = 6;
const resultsCount = computed(() => searchStore.pageData?.totalResultsCount ?? 0);
const pageTitle = computed(() => searchStore.pageData?.seoMeta?.pageTitleWithoutResultsCount ?? '');
const loading = computed(() => searchStore.loading || searchStore.pageData?.results === undefined);
</script>

<style scoped lang="scss">
.NoResultsWrapper {
    display: flex;
    flex-direction: column;
    @include PaddingAreas(1, 0);

    .NoResultsText {
        text-align: left;
		@include TextStyle(BodyRegular);

        @include Breakpoint(ExtraLarge, Large) {
			min-width: 30rem;
		}
	}

    .LowResultsContent{
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        :deep(.Selection) {
            @include Breakpoint(Large, ExtraLarge) {
                border-bottom: none;
            }
        }
    }

    .NoResultsRecommendations {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .RemoveFiltersSuggestionsTitle {
            @include TextStyle(HeadingExtraSmall);
        }
    }
}

</style>